import { INode, ITypeNode } from '../Context/FormBuilderContext';

export const defaultTitleNodeData: INode['data'] = {
  title: 'AI-Powered Form Builder',
  styles: {
    title: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: 20,
      isBold: true,
      isItalic: false,
      isUnderlined: false,
      textAlign: 'left',
      color: '#101828',
    },
    backgroundColor: '#ffffff',
    borderRadius: 16,
    borderColor: '#EAECF0',
    borderWeight: 1,
    verticalAlign: 'center',
    padding: 16,
  },
};

export const defaultShortTextNodeData: INode['data'] = {
  text: 'AI helps you build smarter forms. It adapts to your needs instantly. Save time with intelligent automation',
  styles: {
    shortText: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: 14,
      isBold: false,
      isItalic: false,
      isUnderlined: false,
      textAlign: 'left',
      color: '#475467',
    },
    backgroundColor: '#ffffff',
    borderRadius: 16,
    borderColor: '#EAECF0',
    borderWeight: 1,
    verticalAlign: 'center',
    padding: 16,
  },
};

export const defaultImageNodeData: INode['data'] = {
  url: '',
  styles: {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    borderColor: '#EAECF0',
    borderWeight: 1,
    verticalAlign: 'center',
    padding: 16,
  },
};

export const defaultInputNodeData: INode['data'] = {
  varDataInputId: '',
  fieldType: 'data',
  requiredField: false,
  allowedFiles: [],
  minRows: 3,
  title: 'Project Name',
  subtitle: 'Enter the name of your AI project',
  styles: {
    title: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: 20,
      isBold: true,
      isItalic: false,
      isUnderlined: false,
      textAlign: 'left',
      color: '#101828',
    },
    subtitle: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: 14,
      isBold: false,
      isItalic: false,
      isUnderlined: false,
      textAlign: 'left',
      color: '#475467',
    },
    verticalAlign: 'center',
    backgroundColor: '#ffffff',
    borderRadius: 16,
    borderColor: '#EAECF0',
    borderWeight: 1,
    padding: 16,
  },
};

export const defaultOutputNodeData: INode['data'] = {
  varDataInputId: '',
  fieldType: 'standard',
  title: 'AI Generated Result',
  subtitle: 'Here is the output based on your input',
  styles: {
    title: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: 20,
      isBold: true,
      isItalic: false,
      isUnderlined: false,
      textAlign: 'left',
      color: '#101828',
    },
    subtitle: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: 14,
      isBold: false,
      isItalic: false,
      isUnderlined: false,
      textAlign: 'left',
      color: '#475467',
    },
    backgroundColor: '#ffffff',
    borderRadius: 16,
    borderColor: '#EAECF0',
    borderWeight: 1,
    verticalAlign: 'center',
    padding: 16,
  },
};

export const defaultListNodeData: INode['data'] = {
  title: 'AI Use Cases',
  listItems: [
    {
      description: 'AI-powered form builder',
    },
    {
      description: 'AI-powered chatbot',
    },
  ],
  question: 'Where would you like to apply AI?',
  typeQuestion: 'single',
  varDataInputId: '',
  requiredField: false,
  styles: {
    title: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: 20,
      isBold: true,
      isItalic: false,
      isUnderlined: false,
      textAlign: 'left',
      color: '#101828',
    },
    question: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: 14,
      isBold: false,
      isItalic: false,
      isUnderlined: false,
      textAlign: 'left',
      color: '#475467',
    },
    backgroundColor: '#ffffff',
    borderRadius: 16,
    borderColor: '#EAECF0',
    borderWeight: 1,
    verticalAlign: 'center',
    padding: 16,
  },
};

export const defaultSubmitNodeData: INode['data'] = {
  removeOrRetain: true,
  redirectPageId: undefined,
  styles: {
    submit: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: 16,
      isBold: false,
      isItalic: false,
      isUnderlined: false,
      textAlign: 'center',
      color: '#ffffff',
      buttonBackgroundColor: '#3650DE',
    },
    backgroundColor: '#ffffff',
    borderRadius: 14,
    borderColor: '#EAECF0',
    borderWeight: 1,
    verticalAlign: 'center',
    padding: 16,
  },
};

export function getDefaultNodeData(type: ITypeNode): INode['data'] {
  switch (type) {
    case ITypeNode.TITLE:
      return defaultTitleNodeData;
    case ITypeNode.SHORT_TEXT:
      return defaultShortTextNodeData;
    case ITypeNode.IMAGE:
      return defaultImageNodeData;
    case ITypeNode.INPUT:
      return defaultInputNodeData;
    case ITypeNode.OUTPUT:
      return defaultOutputNodeData;
    case ITypeNode.LIST:
      return defaultListNodeData;
    case ITypeNode.SUBMIT:
      return defaultSubmitNodeData;
    default:
      return {} as INode['data'];
  }
}

